import { useToken } from "@chakra-ui/react";

/**
 * Converts Chakra color token to CSS variable or returns as-is for hex/rgb/rgba/css vars
 */
export const resolveColorToken = (color: string): string => {
  if (
    color.startsWith("var(") ||
    color.startsWith("#") ||
    color.startsWith("rgb") ||
    color.startsWith("rgba") ||
    color.includes("/")
  ) {
    return color;
  }
  return `var(--ck-colors-${color.replace(/\./g, "-")}, ${color})`;
};

/**
 * Resolves Chakra color token to actual color value from theme
 */
export const useResolvedColor = (color: string): string => {
  // Skip useToken for already-resolved colors (rgba, rgb, hex, css vars)
  if (
    color.startsWith("var(") ||
    color.startsWith("#") ||
    color.startsWith("rgb") ||
    color.startsWith("rgba") ||
    color.includes("/")
  ) {
    return color;
  }

  const colorToken = useToken("colors", color);
  const resolved = Array.isArray(colorToken) ? colorToken[0] : colorToken;
  return typeof resolved === "string" && resolved
    ? resolved
    : resolveColorToken(color);
};
